export default {
  FILE_UPLOAD_START: 'FileUploadConstants.FILE_UPLOAD_START',
  FILE_UPLOAD_END: 'FileUploadConstants.FILE_UPLOAD_END',
};
